export default {
  FACEBOOK: 'facebook',
  GOOGLE: 'google-oauth2',
};
